import request from '@/utils/request'

// 查询时效价格分页
export function pageDurationPrice(params) {
  return request({
    url: '/cloudplant/durationPrice/page',
    method: 'post',
    params: params
  })
}

// 查询时效价格列表
export function listDurationPrice(query) {
  return request({
    url: '/cloudplant/durationPrice/list',
    method: 'get',
    params: query
  })
}

// 新增时效价格
export function addDurationPrice(data) {
  return request({
    url: '/cloudplant/durationPrice/add',
    method: 'post',
    data: data
  })
}

// 修改时效价格
export function updateDurationPrice(data) {
  return request({
    url: '/cloudplant/durationPrice/edit',
    method: 'post',
    data: data
  })
}

// 删除时效价格
export function delDurationPrice(data) {
  return request({
    url: '/cloudplant/durationPrice/delete',
    method: 'post',
    data: data
  })
}
